import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ApiExError } from '@shared';
import { AdvisorSponsorship } from '@shared/types/AdvisorSponsorship';

export type SponsorshipCancellationActionProps = {
  advisorId: string;
  sponsorshipId: string;
  source?: 'advisor' | 'sponsor';
};

export type InvitationResponseActionProps = {
  advisorId: string;
  sponsorshipId: string;
  status: 'accept' | 'decline';
};

const sponsorshipSlice = createSlice({
  name: 'sponsorship',
  initialState: initialState.sponsorship,
  reducers: {
    fetchSponsorshipForAdvisorByAdvisorIdRequest(
      state,
      _action: PayloadAction<string>,
    ) {
      state.isLoading = true;
      state.isError = false;
    },
    fetchSponsorshipForAdvisorByAdvisorIdResponse(
      state,
      { payload }: PayloadAction<SponsorshipState>,
    ) {
      Object.assign(state, payload);
      state.isLoading = false;
      state.isError = false;
    },
    fetchSponsorshipForAdvisorByAdvisorIdFailure(
      state,
      _action: PayloadAction<ApiExError>,
    ) {
      state.isLoading = false;
      state.isError = true;
    },
    postCancellationForSponsorshipsBySponsorshipIdRequest(
      state,
      _action: PayloadAction<SponsorshipCancellationActionProps>,
    ) {
      state.isLoading = true;
      state.isError = false;
    },
    postCancellationForSponsorshipsBySponsorshipIdResponse(
      state,
      _action: PayloadAction<AdvisorSponsorship>,
    ) {
      state.isLoading = false;
      state.isError = false;
    },
    postCancellationForSponsorshipsBySponsorshipIdFailure(
      state,
      _action: PayloadAction<ApiExError>,
    ) {
      state.isLoading = false;
      state.isError = true;
    },
    putInvitationResponseForSponsorshipsBySponsorshipIdRequest(
      state,
      _action: PayloadAction<InvitationResponseActionProps>,
    ) {
      state.isLoading = true;
      state.isError = false;
    },
    putInvitationResponseForSponsorshipsBySponsorshipIdResponse(
      state,
      _action: PayloadAction<AdvisorSponsorship>,
    ) {
      state.isLoading = false;
      state.isError = false;
    },
    putInvitationResponseForSponsorshipsBySponsorshipIdFailure(
      state,
      _action: PayloadAction<ApiExError>,
    ) {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const {
  fetchSponsorshipForAdvisorByAdvisorIdRequest,
  fetchSponsorshipForAdvisorByAdvisorIdResponse,
  fetchSponsorshipForAdvisorByAdvisorIdFailure,
  postCancellationForSponsorshipsBySponsorshipIdRequest,
  postCancellationForSponsorshipsBySponsorshipIdResponse,
  postCancellationForSponsorshipsBySponsorshipIdFailure,
  putInvitationResponseForSponsorshipsBySponsorshipIdRequest,
  putInvitationResponseForSponsorshipsBySponsorshipIdResponse,
  putInvitationResponseForSponsorshipsBySponsorshipIdFailure,
} = sponsorshipSlice.actions;

export const sponsorshipReducer = sponsorshipSlice.reducer;
